var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('apexchart', {
    key: _vm.chartKey,
    attrs: {
      "type": "donut",
      "options": _vm.chartOptions,
      "series": _vm.chartSeries,
      "height": "234px"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }